import { useTranslation } from 'react-i18next';

import { ExternalLink, Paragraph } from '@app/shared/ui/atoms/Common';
import { TG_BOT_URL } from '@app/shared/constants/api';

export function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="flex items-center justify-center gap-1">
      <Paragraph variant="primary" size="sm" className="opacity-35">
        {t('auth.no_acc')}
      </Paragraph>
      <ExternalLink url={TG_BOT_URL} className="text-sm font-semibold text-accent">
        {t('auth.sign_up')}
      </ExternalLink>
    </footer>
  );
}
